import {CerbaAuthService} from "@digicerba/common";
import {Http, RequestOptions, XHRBackend} from "@angular/http";
import {HttpOverride} from "./httpOverride";


export function httpFactory(xhrBackend: XHRBackend, requestOptions: RequestOptions, cerbaAuthService: CerbaAuthService): Http {
    return new HttpOverride(xhrBackend, requestOptions, cerbaAuthService);
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/resources/httpOverride.factory.ts